import { useAtomValue } from 'jotai';
import useSWRWithAuth from './useSWRWithAuth.js';
import { baseUrlTrackingApiAtom } from '../atoms/config.js';

/**
 * Fetch the player highlight data from the server.
 *
 * This data works with completed plays only so this data is treated as immutable and won't be refreshed once cached.
 *
 * @param {String} playId
 */
function usePlayerTracksData(playId) {
    const host = useAtomValue(baseUrlTrackingApiAtom);
    const url = `${host}/plays/${playId}/playertracks`;
    return useSWRWithAuth(url, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
}

export { usePlayerTracksData as default };
//# sourceMappingURL=usePlayerTracksData.js.map
